import invokeClient from './invokeClient';
// 设置导航栏右侧按钮
let handleOptionButtonClick;
export const setOptionButton = (params) => {
    if (handleOptionButtonClick) {
        window.removeEventListener('optionButtonClick', handleOptionButtonClick);
    }
    // 将配置数据传给客户端, 注册一个 optionButtonClick 事件，以供客户端触发
    // 触发方法： smartHome.dispatchEvent('optionButtonClick', data)
    handleOptionButtonClick = data => {
        if (typeof params.onClick === 'function') {
            params.onClick(data.detail);
        }
    };
    window.addEventListener('optionButtonClick', handleOptionButtonClick);
    return invokeClient.invoke({
        functionName: 'setOptionButton',
        params: JSON.stringify({ reset: params.reset, items: params.items }),
    });
};
// 设置导航栏右上角弹出的下拉菜单
let handlePopMenuClick;
export const setPopMenu = (params) => {
    if (handlePopMenuClick) {
        window.removeEventListener('popMenuClick', handlePopMenuClick);
    }
    handlePopMenuClick = data => {
        if (typeof params.onClick === 'function') {
            params.onClick(data.detail);
        }
    };
    window.addEventListener('popMenuClick', handlePopMenuClick);
    return invokeClient.invoke({
        functionName: 'setPopMenu',
        params: JSON.stringify({ enabled: params.enabled, items: params.items }),
    });
};
// 当一个页面重新可见时，会触发此事件
export const onResume = (eventHandler) => {
    window.addEventListener('resume', eventHandler);
};
export const offResume = (eventHandler) => {
    window.removeEventListener('resume', eventHandler);
};
// 当一个页面不可见时，会触发此事件
export const onPause = (eventHandler) => {
    window.addEventListener('pause', eventHandler);
};
export const offPause = (eventHandler) => {
    window.removeEventListener('pause', eventHandler);
};
// 当一个页面重新可见时，会触发此事件。
export const onPageResume = (eventHandler) => {
    window.addEventListener('pageResume', eventHandler);
};
// 移除 pageResume 事件的监听
export const offPageResume = (eventHandler) => {
    window.removeEventListener('pageResume', eventHandler);
};
// 当一个页面不可见时，会触发此事件。
export const onPagePause = (eventHandler) => {
    window.addEventListener('pagePause', eventHandler);
};
// 移除 pagePause 事件的监听
export const offPagePause = (eventHandler) => {
    window.removeEventListener('pagePause', eventHandler);
};
// 监听应用压后台事件
export const onAppPause = (eventHandler) => {
    window.addEventListener('appPause', eventHandler);
};
// 移除应用压后台事件的监听
export const offAppPause = (eventHandler) => {
    window.removeEventListener('appPause', eventHandler);
};
// 监听应用从后台唤起事件
export const onAppResume = (eventHandler) => {
    window.addEventListener('appResume', eventHandler);
};
// 移除应用从后台唤起事件的监听
export const offAppResume = (eventHandler) => {
    window.removeEventListener('appResume', eventHandler);
};
// 监听导航栏标题点击事件，在点击文字时才触发，点击导航栏其他空白地方不会触发。
export const onTitleClick = (eventHandler) => {
    window.addEventListener('titleClick', eventHandler);
};
export const offTitleClick = (eventHandler) => {
    window.removeEventListener('titleClick', eventHandler);
};
export const pushWindow = (params) => {
    return invokeClient.invoke({
        functionName: 'pushWindow',
        params: JSON.stringify(params),
    });
};
export const popWindow = (params) => {
    return invokeClient.invoke({
        functionName: 'popWindow',
        params: JSON.stringify(params),
    });
};
export const finish = () => invokeClient.invoke({
    functionName: 'finish'
});
export const redirectTo = (option) => {
    let url;
    if (typeof option === 'object') {
        const searchParams = new URLSearchParams();
        for (const key in option.data) {
            if (option.data.hasOwnProperty(key)) {
                searchParams.append(key, option.data[key]);
            }
        }
        url = `${option.url}?${searchParams.toString()}`;
    }
    else {
        url = option;
    }
    if (window.m2w && window.m2w.popHistory) {
        invokeClient
            .invoke({
            functionName: 'popHistory',
        })
            .then(() => {
            window.location.replace(url);
        });
    }
    else {
        window.location.replace(url);
    }
};
//# sourceMappingURL=data:application/json;base64,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